<table>
  <thead>
    <th></th>
    <th *ngFor="let day of month[0]" class="ds-font-display">
      <span>{{ day | date: "EEEEE" }}</span>
    </th>
  </thead>
  <tbody>
    <tr
      *ngFor="let week of month"
      (click)="select(week[0])"
      class="ds-week focus:ds-outline-none focus:ds-bg-primary-blue-50"
      (keydown.enter)="select(week[0])"
      [attr.tabindex]="isDisabled(week[0]) ? '-1' : '0'"
    >
      <td
        class="ds-day ds-text-primary-gray-70"
        [ngClass]="{
          'ds-is-selected': isSelectedWeek(week[0]) && !isDisabled(week[0]),
          'ds-is-disabled': isDisabled(week[0])
        }"
      >
        <span>{{ week[0] | date: "ww" }}</span>
      </td>
      <ui-day
        *ngFor="let day of week"
        [day]="day"
        [selected]="selected"
        [min]="min"
        [max]="max"
        (selectedDayChange)="select($event)"
        [isDisabled]="isDisabled(day)"
        [isSelected]="isSelectedWeek(day) && !isDisabled(day)"
      ></ui-day>
    </tr>
  </tbody>
</table>
